/**
 * Skeleton – loading placeholder for text, avatars, tags, and buttons.
 */

import type { HTMLAttributes } from 'react';

import { buildClassName } from '@utils';

import './Skeleton.css';

export type SkeletonVariant = 'line' | 'circle' | 'pill' | 'button';

export type SkeletonLineSize = 'sm' | 'md' | 'lg';

export interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
  /** Shape preset */
  variant?: SkeletonVariant;
  /** Line height when variant is line */
  lineSize?: SkeletonLineSize;
  /** Inline width (e.g. "45%", "5rem") */
  width?: string;
}

function lineSizeClass(lineSize: SkeletonLineSize): string {
  if (lineSize === 'lg') return 'bhg-skeleton--line-lg';
  if (lineSize === 'sm') return 'bhg-skeleton--line-sm';
  return 'bhg-skeleton--line-md';
}

export function Skeleton({
  variant = 'line',
  lineSize = 'md',
  width,
  className,
  style,
  ...rest
}: SkeletonProps) {
  const lineClass = variant === 'line' ? lineSizeClass(lineSize) : null;

  return (
    <span
      className={buildClassName(
        'bhg-skeleton',
        variant === 'circle' && 'bhg-skeleton--circle',
        variant === 'pill' && 'bhg-skeleton--pill',
        variant === 'button' && 'bhg-skeleton--button',
        variant === 'line' && 'bhg-skeleton--line',
        lineClass,
        className
      )}
      style={width ? { ...style, width, maxWidth: width } : style}
      aria-hidden
      {...rest}
    />
  );
}
